// useIsDesktop.js
import { useEffect, useState } from "react";

export default function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(
    () =>
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(min-width: 1280px)").matches
  );

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    ) {
      return;
    }

    const mq = window.matchMedia("(min-width: 1280px)");
    const handler = (e) => setIsDesktop(e.matches);

    // New API
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }

    // Fallback (older Safari)
    mq.addListener(handler);
    return () => mq.removeListener(handler);
  }, []);

  return isDesktop;
}
